import React from 'react'
import PropTypes from 'prop-types'
import {graphql} from 'gatsby'
import Layout from '../components/Layout'
import Content, {HTMLContent} from '../components/Content'
import * as _ from 'lodash'
import ContactForm from "../components/ContactForm";
import * as helper from "../utils";
import { scrollToElement } from "../components/utils";

export const TreeSurveysAndInspectionsPageTemplate = ({title, subtitle, image, cards, topSection, process, contentComponent}) => {
    const PageContent = contentComponent || Content

    return (
        <React.Fragment>
            <section className={'hero is-large'}>
                <div className="hero-body margin-top-0 has-black-overlay overlay-dark"
                     style={{
                         backgroundImage: `url(${
                             !!image.childImageSharp
                                 ? image.childImageSharp.fluid.src
                                 : image
                             })`,
                         backgroundPosition: `center bottom`,
                         backgroundAttachment: `fixed`,
                         backgroundSize: 'cover',
                         backgroundRepeat: 'no-repeat'
                     }}>
                    <div style={{
                        display: 'flex',
                        height: '150px',
                        lineHeight: '1',
                        justifyContent: 'space-around',
                        alignItems: 'left',
                        flexDirection: 'column',
                        opacity: '0.99'
                    }}>
                        <p className="h1 is-size-4-mobile is-size-1-tablet is-size-1-widescreen"
                           style={{
                               // boxShadow: 'rgb(255, 68, 0) 0.5rem 0px 0px, rgb(255, 68, 0) -0.5rem 0px 0px',
                               // backgroundColor: 'rgb(255, 68, 0)',
                               textAlign: 'center',
                               fontFamily: 'Museo',
                               fontWeight: '500',
                               color: 'white',
                               lineHeight: '1.2',
                               padding: '0.25em',
                               // maxWidth: '54vh',
                               margin: '0 auto',
                               whiteSpace: 'pre-line'
                           }}>
                            {title}
                        </p>
                        <h3 className="is-size-6-mobile is-size-5-tablet is-size-4-widescreen"
                            style={{
                                // boxShadow: 'rgb(255, 68, 0) 0.5rem 0px 0px, rgb(255, 68, 0) -0.5rem 0px 0px',
                                // backgroundColor: 'rgb(255, 68, 0)',
                                textAlign: 'center',
                                color: 'white',
                                lineHeight: '1.2',
                                padding: '0.25em',
                                maxWidth: '96%',
                                width: '54vh',
                                margin: '0 auto',
                                letterSpacing: '0.5px'
                            }}>
                            {subtitle}
                        </h3>
                    </div>
                </div>
            </section>

            {/*<section className={'half-overlay-top is-hidden-mobile'}>*/}
            {/*    <div className={'container'}>*/}
            {/*        <div className="columns">*/}
            {/*            {_.map(cards, service => {*/}
            {/*                return <div className="column">*/}
            {/*                    <div className={'card no-padding white-bg rounded-corners'}>*/}
            {/*                        <div className={'card-header has-padding white-bg float-icon pb-0'}>*/}
            {/*                            <div className={'icon-circle-container'}>*/}
            {/*                                <div className={'icon-circle primary-bg'}>*/}
            {/*                                    <i className={service.icon + (' font-white')}></i>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                            <h3 className="card-title font-primary has-text-centered">*/}
            {/*                                {service.title}*/}
            {/*                            </h3>*/}
            {/*                            <p className="card-subtitle has-text-centered">{service.subtitle}</p>*/}
            {/*                        </div>*/}
            {/*                        <div className={'card-body pt-2'}>*/}
            {/*                            <p className={'card-first-para'}>{service.text}</p>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            })}*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}
            <section className={'section dark-green-bg border-top-primary'}>
                <h4 className={'has-text-centered font-primary'}>/ &nbsp;{topSection.title} &nbsp;/</h4>
                <div className={'centered-text-container line-left font-white'}>
                    <p className={'text-first-para font-white'}>{helper.parse(topSection.firstPara)}</p>
                </div>
              <div className={'has-text-centered font-primary'}>
                <a onClick={_=>scrollToElement('#contact')} className={'button primary-bg border-primary font-white is-size-2 is-size-4'}>Get your quote</a>
              </div>
            </section>

                            <section className={'section light-green-bg border-top-primary'}>
                <div className={'container'}>
                  <div className={'columns is-centered'}>
                  <div className={'column is-half-fullhd is-three-fifths-desktop is-three-quarters-tablet'}>
                    <div className={'font-dark-green mb-4 p-3 rounded-corners thin-border-primary'}>
                    <h5 className={'has-text-centered font-primary mb-3 is-size-4'}><i className={'fal fa-info-circle mr-1'}></i>&nbsp;{process.intro}</h5>
                    <p className={'text'}>{helper.parse(topSection.text)}</p>
                    </div>
                  </div>
                  </div>
                    {_.map(process.stages, (stage, index) => {
                        return <>
                    {/*{index === 0 ? <h5 className={'has-text-centered font-primary white-bg mb-4 p-3 rounded-corners thin-border-primary'}><i className={'fal fa-info-circle mr-1'}></i>&nbsp;{process.intro}</h5> : ''}*/}
                        <div className={'columns is-variable mobile-margin-bottom justify-content-center'}>

                            {_.map(stage.children, (child, index) => {
                                let colspan = ' is-12';
                                return <div className={"column mt-5"+colspan}>
                                    <div className={'card no-padding white-bg rounded-corners'}>
                                      <div className={'columns is-gapless rounded-corners'} style={{overflow: 'hidden'}}>
                                        <div className={'column is-4-desktop is-relative'} style={{order: index % 2, minHeight: '200px' }}>
                                          <div style={{
                                            position: 'absolute',
                                            inset: 0,
                                            backgroundImage: `url(${
                                              !!child.image.childImageSharp
                                                ? child.image.childImageSharp.fluid.src
                                                : child.image
                                            })`,
                                            backgroundPosition: `center center`,
                                            backgroundSize: 'cover',
                                            backgroundRepeat: 'no-repeat'
                                          }}/>
                                        </div>
                                        <div className={'column is-8-desktop'}>
                                          <div className={'card-header no-rounded has-padding primary-bg float-icon relative-mobile'}>
                                            <div className={'icon-circle-container half two-thirds-desktop'}>
                                              <div className={'icon-circle border-primary'}>
                                                <i className={child.icon}></i>
                                              </div>
                                            </div>
                                            <h3 className="card-title font-white has-text-centered px-3">
                                              {child.title}
                                            </h3>
                                            <p className="card-subtitle has-text-centered">{child.subtitle}</p>
                                          </div>
                                          <div className={'card-body'}>
                                            <p className={'card-first-para'}>{child.firstPara}</p>
                                            <p>{helper.parse(child.text)}</p>
                                          </div>
                                          <div className={'card-footer'}>
                                            <a className={'font-mint'} onClick={_ => scrollToElement('#contact')}>Get
                                              quote</a>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                </div>
                            })}

                        </div>
                            </>
                    })}
                </div>
            </section>
          <section className={'section mid-green-bg border-top-primary py-6'}>
                  <div className={'columns is-centered'}>
                    <div className={'column mx-3 has-background-white p-3 rounded-corners is-half-fullhd is-three-fifths-desktop is-three-quarters-tablet'}>
                      <h3 id='contact' className={'is-ligna-font font-primary has-text-centered has-text-primary'}>/ &nbsp;Get your quote &nbsp;/</h3>
                      <hr className={'my-3'}/>
                      <ContactForm name={'tree-surveys-and-inspections-enquiry'}/>
                    </div>
                  </div>
          </section>
        </React.Fragment>
    )
}

TreeSurveysAndInspectionsPageTemplate.propTypes = {
    // title: PropTypes.string.isRequired,
    // content: PropTypes.string,
    // contentComponent: PropTypes.func,
    data: PropTypes.shape({
        markdownRemark: PropTypes.shape({
            frontmatter: PropTypes.object,
        }),
    }),
}

const TreeSurveysAndInspectionsPage = ({data}) => {
    // const {markdownRemark: post} = data
    const {frontmatter} = data.markdownRemark

    return (
        <Layout>
            <TreeSurveysAndInspectionsPageTemplate
                contentComponent={HTMLContent}
                title={frontmatter.title}
                subtitle={frontmatter.subtitle}
                image={frontmatter.image}
                cards={frontmatter.cards}
                topSection={frontmatter.topSection}
                process={frontmatter.process}
            />
        </Layout>
    )
}

TreeSurveysAndInspectionsPage.propTypes = {
    data: PropTypes.object.isRequired,
}

export default TreeSurveysAndInspectionsPage

export const TreeSurveysAndInspectionsPageQuery = graphql`
  query TreeSurveysAndInspectionsPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        subtitle
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        cards {
            title
            icon
            text
        }
        topSection {
            title
            firstPara
            text
        }
        process {
            intro
            stages {
                children {
                    title
                    colSpan
                    icon
                    firstPara
                    text
                    image {
                      childImageSharp {
                        fluid(maxWidth: 2048, quality: 100) {
                          ...GatsbyImageSharpFluid
                        }
                      }
                    }
                }
            }
        }
      }
    }
  }
`
